module.exports = __webpack_public_path__ + "img/home_ic2.83e67dfd.jpg";